import React, { useEffect, useRef, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";
import Cookies from "js-cookie";
const apiUrl = process.env.REACT_APP_API_URL;

// Translations for English, Hindi, and Kannada
const translations = {
  en: {
    header: "Languages Used",
    ok: "OK",
    errorSelect: "Please select an option before proceeding.",
    alert: "Please answer the current question before proceeding to the next one.",
  },
  Hi: {
    header: "उपयोग की गई भाषाएँ",
    ok: "ठीक है",
    errorSelect: "कृपया आगे बढ़ने से पहले एक विकल्प चुनें।",
    alert: "कृपया अगले प्रश्न पर जाने से पहले वर्तमान प्रश्न का उत्तर दें।",
  },
  Kn: {
    header: "ವಂಚಕರು ಯಾವ ಭಾಷೆಯಲ್ಲಿ ಸಂಪರ್ಕಿಸಿದರು.",
    ok: "ಸರಿ",
    errorSelect: "ದಯವಿಟ್ಟು ಮುಂದುವರೆಯುವ ಮೊದಲು ಆಯ್ಕೆಮಾಡಿ.",
    alert: "ದಯವಿಟ್ಟು ಮುಂದಿನ ಪ್ರಶ್ನೆಗೆ ಹೋಗುವ ಮೊದಲು ಪ್ರಸ್ತುತ ಪ್ರಶ್ನೆಗೆ ಉತ್ತರ ನೀಡಿ.",
  },
};

const SuspectSpeak = ({
  onNext,
  onSuspectSpeakSelected,
  onQuestion,
  apiKey,
  botToken,
  vist_id,
  app_ver,
  answer,
  selectedLang
}) => {
  const [selectedOptions, setSelectedOptions] = useState({
    contactValues: [],
    contactIds: [],
  });
  const [rawSpeckData, setRawSpeckData] = useState(null);
  const [showOkButton, setShowOkButton] = useState(true);
  const [error, setError] = useState(null);
  const [speckOptions, setSpeckOptions] = useState([]);
  const [previousSelected, setPreviousSelected] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false); // Audio play status
  const audioRef = useRef(null);

  // Mapping language codes to audio source files
  const audioMap = {
    en: "audio/English BOT Audios/suspectspeak.mp3",
    Hi: "audio/Hindi BOT Audios/Hindi-Audio16.mp3",
    Kn: "audio/Kannada BOT Audios/Kannada-Audio16.m4a",
    tcy: "audio/cybervictim_tcy.mp3",
  };



  // Update audio source on language or play status change
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.src = audioMap[selectedLang] || audioMap["en"];
      audioRef.current.load();
      if (isPlaying) {
        audioRef.current.play();
      }
    }
  }, [selectedLang, isPlaying]);

       useEffect(() => {
           const handler = () => {
            if (audioRef.current) {
               audioRef.current.pause();
               audioRef.current.currentTime = 0;
                setIsPlaying(false);
              }
            };
            window.addEventListener('pauseAllAudio', handler);
            return () => window.removeEventListener('pauseAllAudio', handler);
          }, []);

  // Load stored selected options from localStorage (if available)
  useEffect(() => {
    const storedData = localStorage.getItem("suspectSpeck");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setSelectedOptions(parsedData);
      onSuspectSpeakSelected(parsedData);
      setPreviousSelected(parsedData);
    }
  }, []);


    const getSpeckList = (resp, language) => {
      switch (language) {
        case "en":
          return resp.lang_eng;
        case "Hi":
          return resp.lang_hin;
        case "Kn":
          return resp.lang_kanada;
        default:
          return resp.lang_eng; // fallback
      }
    };
  
  
    useEffect(() => {
      if (rawSpeckData) {
        const speckList = getSpeckList(rawSpeckData, selectedLang) || [];
        setSpeckOptions(
          speckList.map((speck, index) => ({
            id: String.fromCharCode(65 + index),
            value: speck.lang_uniq,
            label: speck.lang_nm,
          })) || []
        );
      }
    }, [selectedLang, rawSpeckData]);

  // Fetch options for suspect speak from API
  useEffect(() => {
    const fetchSpeckData = async () => {
      try {
        const response = await fetch(`${apiUrl}/v1/cy_ma_lang_list`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            api_key: apiKey,
            visitor_token: vist_id,
            qtion_id: "66f653bf26e9c",
            lac_token: botToken,
            app_ver: app_ver,
            bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
          }),
        });
        if (!response.ok) {
          throw new Error("Failed to fetch options");
        }
        const speckData = await response.json();
        setRawSpeckData(speckData.resp);

        // setSpeckOptions(
        //   data.resp.lng_list.map((item, index) => ({
        //     id: String.fromCharCode(65 + index),
        //     value: item.lang_uniq,
        //     label: item.lang_nm,
        //   })) || []
        // );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchSpeckData();
  }, [apiKey, app_ver, botToken, vist_id]);

  const handleOptionClick = (option, e) => {
    e.preventDefault();
    setShowOkButton(true);
    setError("");
    setSelectedOptions((prev) => {
      let updatedOptions;
      if (prev.contactValues.includes(option.value)) {
        // Remove selection if already selected
        updatedOptions = {
          contactValues: prev.contactValues.filter((val) => val !== option.value),
          contactIds: prev.contactIds.filter((id) => id !== option.id),
        };
      } else {
        updatedOptions = {
          contactValues: [...prev.contactValues, option.value],
          contactIds: [...prev.contactIds, option.id],
        };
      }
      localStorage.setItem("suspectSpeck", JSON.stringify(updatedOptions));
      onSuspectSpeakSelected(updatedOptions);
      return updatedOptions;
    });
  };

  const saveDataToAPI = async (selectedOptions) => {
    try {
      const response = await fetch(`${apiUrl}/v1/ccrim_bot_add_multichoice`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          api_key: apiKey,
          visitor_token: vist_id,
          qtion_id: "66f653bf26e9c",
          qtion_num: "14",
          qtion_option: selectedOptions.contactIds,
          option_val: selectedOptions.contactValues,
          app_ver: app_ver,
          lac_token: botToken,
          bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to save data");
      }
      const data = await response.json();
      if (data.resp.error_code === "0") {
        onSuspectSpeakSelected(selectedOptions);
        onNext(16);
        onQuestion(17);
      } else {
        setError("Failed to push data to API");
      }
    } catch (error) {
      console.error("Error saving data:", error);
      setError("Failed to save data, please try again.");
    }
  };

  const handleOkClick = async (e) => {
    e.preventDefault();
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
    onSuspectSpeakSelected(selectedOptions);
    if (
      JSON.stringify(selectedOptions) !== JSON.stringify(previousSelected)
    ) {
      if (selectedOptions.contactValues.length > 0) {
        await saveDataToAPI(selectedOptions);
        setPreviousSelected(selectedOptions);
      } else {
        setError('errorSelect');
        setShowOkButton(false);
        return;
      }
    } else {
      onNext(16);
      onQuestion(17);
    }
  };

  const toggleAudio = (e) => {
    e.preventDefault();
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
  };

  return (
    <div className="question">
      <div style={{ display: "flex" }}>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-end" }}>
          <div style={{ display: "flex" }}>
            <h2>
              {translations[selectedLang].header} <span style={{ color: "red" }}>*</span>
            </h2>
            <button onClick={toggleAudio} className="audio-button">
              {isPlaying ? <FaPause color="White" size={12} style={{ marginBottom: '20px' }} /> : <FaPlay color="White" size={12} style={{ marginBottom: '20px' }}/>}
            </button>
          </div>
          <audio ref={audioRef} onEnded={handleAudioEnd}>
            <source src={audioMap[selectedLang]} type="audio/mp3" />
            Your browser does not support the audio element.
          </audio>
          <div className="option-list" style={{ position: "relative", zIndex: "9" }}>
            {speckOptions.map((option) => (
              <button
                key={option.id}
                className={`option-button ${
                  selectedOptions.contactValues.includes(option.value) ? "selected" : ""
                }`}
                onClick={(e) => handleOptionClick(option, e)}
              >
                <div className="answer-container">
                  <div
                    className="option"
                    style={{
                      backgroundColor: selectedOptions.contactValues.includes(option.value)
                        ? "#000"
                        : "#fff",
                      color: selectedOptions.contactValues.includes(option.value)
                        ? "#fff"
                        : "#000",
                    }}
                  >
                    {option.id}
                  </div>
                  <div className="option-label" style={{ textAlign: "start" }}>
                    {option.label}
                  </div>
                </div>
                {selectedOptions.contactValues.includes(option.value) && (
                  <span className="checkmark">&#10003;</span>
                )}
              </button>
            ))}
          </div>
          <div style={{ position: "relative", zIndex: "1000", marginTop: "-2px" }}>
            {showOkButton && (
              <button type="button" className="ok-btn" onClick={handleOkClick}>
                {translations[selectedLang].ok}
              </button>
            )}
          </div>
          {answer[15] && (
            <p className="alert-box" style={{ position: "relative", zIndex: "1000" }}>
              {translations[selectedLang].alert}
            </p>
          )}
          {error && (
            <div className="error-message" style={{ position: "relative", zIndex: "1000" }}>
              {translations[selectedLang][error]}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SuspectSpeak;
